export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
          {/* Image - overlaps left */}
          <div className="w-full lg:w-[38%] lg:-ml-8 relative z-10">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20young%20professional%20woman%20working%20on%20laptop%20at%20a%20bright%20coffee%20shop%2C%20lifestyle%20portrait%20photography%2C%20warm%20natural%20lighting%2C%20genuine%20smile%2C%20modern%20urban%20setting%2C%20casual%20stylish%20outfit%2C%20authentic%20moment&width=600&height=750&seq=testimonial-img-v2-001&orientation=portrait"
                alt="LitBuy Spreadsheet user workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Review text */}
          <div className="w-full lg:w-[62%] lg:pl-14">
            <div className="max-w-[540px]">
              <div className="text-6xl md:text-8xl font-heading text-accent-300 leading-none mb-4">&ldquo;</div>
              <blockquote className="font-heading text-xl md:text-2xl lg:text-3xl font-medium text-foreground-900 leading-relaxed mb-8">
                LitBuy Spreadsheet completely transformed how I track deals across categories. The templates saved me hours of setup time, and the comparison features helped me save over 30% on my shopping across Shoes, Hoodies, and Accessories in just the first month.
              </blockquote>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-600 font-semibold text-sm">SM</span>
                </div>
                <div>
                  <span className="block text-sm font-semibold text-foreground-900">Sarah Mitchell</span>
                  <span className="block text-xs text-foreground-500">Verified LitBuy Spreadsheet User</span>
                </div>
              </div>

              <div className="flex items-center gap-1 mt-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
                <span className="text-xs text-foreground-500 ml-2">5.0 Rating</span>
              </div>

              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-secondary-100 text-secondary-800 font-semibold text-sm hover:bg-secondary-200 transition-all whitespace-nowrap cursor-pointer"
              >
                Read More Reviews
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}